import React from 'react';


export default function DefaultServiceImage() {
  return (
   <svg width="320" height="320" viewBox="0 0 320 320" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path d="M176.5 138.667H176.553M133.833 112H192.5C196.743 112 200.813 113.686 203.814 116.686C206.814 119.687 208.5 123.757 208.5 128V186.667M203.935 203.195C202.444 204.716 200.665 205.925 198.702 206.75C196.738 207.576 194.63 208 192.5 208H128.5C124.257 208 120.187 206.314 117.186 203.314C114.186 200.313 112.5 196.243 112.5 192V128C112.5 123.493 114.361 119.424 117.353 116.517M112.5 181.333L139.167 154.667C144.116 149.904 150.217 149.904 155.167 154.667L181.833 181.333M183.593 161.803C186.655 161.515 189.753 162.688 192.5 165.333L208.5 181.333M112.5 112L208.5 208" stroke="#071013" strokeOpacity="0.5" strokeWidth="4" strokeLinejoin="round" strokeDasharray="4 12"/>
</g>
</svg>

  )
}
